export default __webpack_public_path__ + "static/media/warn-icon.3e01a9a0.png";